import api from './index'

export default {
	login (data, payload) {
		return api.fetch('/app/user/login', {
			method: 'POST',
			body: api.buildFormData(api.csrfPrepare(data))
		}, payload)
	},
	logout (payload) {
		return api.fetch('/app/user/logout', {
			method: 'POST',
			body: api.buildFormData(api.csrfPrepare({}))
		}, payload)
	},
	signup (data, payload) {
		return api.fetch('/app/user/signup', {
			method: 'POST',
			body: api.buildFormData(api.csrfPrepare(data))
		}, payload)
	},
	activate (data, payload) {
		return api.fetch('/app/user/activate', {
			method: 'POST',
			body: api.buildFormData(api.csrfPrepare(data))
		}, payload)
	},
	forgot (data, payload) {
		return api.fetch('/app/user/forgot', {
			method: 'POST',
			body: api.buildFormData(api.csrfPrepare(data))
		}, payload)
	},
	reset (data, payload) {
		return api.fetch('/app/user/reset', {
			method: 'POST',
			body: api.buildFormData(api.csrfPrepare(data))
		}, payload)
	},
	check (data, payload) {
		return api.fetch('/app/user/check', {
			method: 'POST',
			body: api.buildFormData(api.csrfPrepare(data))
		}, payload)
	}
}



// WEBPACK FOOTER //
// ./src/api/user.js